/* tslint:disable */
/* eslint-disable */
/**
 * Payment App-Tier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PaymentTransactionStatus = {
    Initiated: 'INITIATED',
    InitiatedFailed: 'INITIATED_FAILED',
    Authorized: 'AUTHORIZED',
    AuthorizeFailed: 'AUTHORIZE_FAILED',
    Captured: 'CAPTURED',
    CapturedFailed: 'CAPTURED_FAILED',
    Void: 'VOID',
    VoidFailed: 'VOID_FAILED',
    VoidPending: 'VOID_PENDING',
    Inactive: 'INACTIVE',
    Verified: 'VERIFIED',
    InitiateRefund: 'INITIATE_REFUND',
    Refunded: 'REFUNDED',
    RefundPending: 'REFUND_PENDING',
    RefundFailed: 'REFUND_FAILED',
    Awaited: 'AWAITED',
    Aborted: 'ABORTED',
    RefundInitiated: 'REFUND_INITIATED',
    Cancelled: 'CANCELLED',
    CancelPending: 'CANCEL_PENDING',
    CancelFailed: 'CANCEL_FAILED',
    VerifiedFailed: 'VERIFIED_FAILED'
} as const;
export type PaymentTransactionStatus = typeof PaymentTransactionStatus[keyof typeof PaymentTransactionStatus];


export function PaymentTransactionStatusFromJSON(json: any): PaymentTransactionStatus {
    return PaymentTransactionStatusFromJSONTyped(json, false);
}

export function PaymentTransactionStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentTransactionStatus {
    return json as PaymentTransactionStatus;
}

export function PaymentTransactionStatusToJSON(value?: PaymentTransactionStatus | null): any {
    return value as any;
}

